import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-resource/oss/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-resource/oss/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-resource/oss/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-resource/oss/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-resource/oss/submit',
    method: 'post',
    data: row
  })
}

export const downloadFile = (fileUrl,fileName) => {
    var url = "/api/v4ward/oss/customEndpoint/downloadFile?fileUrl="+fileUrl+"&fileName="+fileName;
    var  a = document.createElement('a');           // 创建隐藏的可下载链接
    a.download = fileName;
    a.style.display = 'none';
    a.href = url;
    document.body.appendChild(a);
    a.click();                                                       // 触发点击
    document.body.removeChild(a);                  // 然后移除
}

export const enable = (id) => {
  return request({
    url: '/api/blade-resource/oss/enable',
    method: 'post',
    params: {
      id
    }
  })
}
